import {MITTWALD_API, Schemas} from '../middleware/MittwaldApi'
import * as ActionTypes from '../constants/ActionTypes'

import {putFormData} from './FormData'

import * as Errors from '../constants/Errors'
import {getCartId, getCartItems, getCartPromotionCode} from "../selectors/SimpleSelectors";
import {getPromotionCodeForm} from "../selectors/Forms";

// **************************************************************************************************************
const fetchPromotionCodeStatus = (bearer, articles, promotionCode) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.PROMOTIONCODE_VALIDATE_REQUEST, ActionTypes.PROMOTIONCODE_VALIDATE_SUCCESS, ActionTypes.PROMOTIONCODE_VALIDATE_FAILURE],
        endpoint: `promotioncodes/${promotionCode}/actions/validate`,
        bearer: bearer,
        schema: Schemas.PROMOTIONCODESTATUS,
        method: 'POST',
        postData: {
            articles: articles
        },
        payload: {
            promotionCode: promotionCode
        }
    }
})

const promotionCodeValidationFailure = (errorMessage, payload = {}) => {
    return {
        type: ActionTypes.PROMOTIONCODE_VALIDATE_FAILURE,
        error: errorMessage,
        status: 404,
        payload: payload
    }
}

const fetchPromotionCodeData = (bearer, cartId, promotionCode) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.PROMOTIONCODE_DATA_REQUEST, ActionTypes.PROMOTIONCODE_DATA_SUCCESS, ActionTypes.PROMOTIONCODE_DATA_FAILURE],
        endpoint: `promotioncodes/${promotionCode}`,
        bearer: bearer,
        schema: Schemas.PROMOTIONCODE,
        method: 'GET',
        postData: {},
        payload: {
            promotionCode: promotionCode
        }
    }
})

const resetPromotionCode = () => ({
    type: ActionTypes.PROMOTIONCODE_RESET
})

const initializePromotionCode = (code) => ({
    type: ActionTypes.PROMOTIONCODE_INIT
})

export const queryPromotionCodeInit = () => (dispatch, getState) => {

    const code = getCartPromotionCode(getState())
    if (!code) {
        return
    }
    dispatch(initializePromotionCode(code))
    dispatch(fetchPromotionCodeData(getState().token.bearer, getCartId(getState()), code))

}

export const queryPromotionCodeStatusAndData = () => (dispatch, getState) => {

    const code = (getPromotionCodeForm(getState()) && getPromotionCodeForm(getState()).values) ? getPromotionCodeForm(getState()).values.promotionCode : null
    const articles = getCartItems(getState()).map((val) => {
        return {
            articleNumber: val.identifier
        }
    })

    const wasValidatedBefore = getState().promotionCode.validatedPromotionCode


    if (!code) {
        dispatch(resetPromotionCode())
        if (wasValidatedBefore) {
            dispatch(putFormData())
        }
    } else {
        return Promise.all([
            dispatch(fetchPromotionCodeStatus(getState().token.bearer, articles, code))
        ]).then((args) => {

            if (args[0].type === ActionTypes.PROMOTIONCODE_VALIDATE_SUCCESS) {

                return Promise.all([
                    dispatch(fetchPromotionCodeData(getState().token.bearer, getCartId(getState()), code))
                ]).then((args) => {
                    return dispatch(putFormData())
                })

            } else {
                if (wasValidatedBefore) {
                    dispatch(putFormData())
                }
                // load promotionCode data if code is valid but articles not matching
                if (args[0].error === Errors.PROMOTION_CODE_FALSE_ARTICLES) {
                    return dispatch(fetchPromotionCodeData(getState().token.bearer, getCartId(getState()), code))
                }
            }
        })
    }
}

export const queryPromotionCodeIfArticleInCode = (articleNumber) => (dispatch, getState) => {
    // update promotioncode if article is matching promotioncode data
    const codeInformation = getState().promotionCode.codeInformation

    const isArticleNumberIncluded = codeInformation && codeInformation.articles && codeInformation.articles.includes(articleNumber)

    const isMonthlyDisabled = codeInformation && !codeInformation.monthly

    if (isArticleNumberIncluded || isMonthlyDisabled) {
        return dispatch(queryPromotionCodeStatusAndData())
    }

}



/** WEBPACK FOOTER **
 ** ./src/actions/PromotionCode.js
 **/